import CheckTree from './CheckTree';

// export types
export type { CheckTreeProps } from './CheckTree';
export type { CheckTreeNodeProps } from './CheckTreeNode';

// export components
export { CheckTree };
export default CheckTree;
